import { Divider, Form, Input } from "antd";
import { FC, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import environment from "setup/environment";

import { PreviewBoxProps } from "./types";

const PreviewBox: FC<PreviewBoxProps> = ({ eventUrlIds }) => {
  const [previewUrl, detailsUrl] = useMemo(() => {
    const details = eventUrlIds?.eventDetails
      ? `${environment.WIDGET_DOMAIN}/#/event/${eventUrlIds?.eventDetails}`
      : "";
    const preview = eventUrlIds?.preview
      ? `${environment.WIDGET_DOMAIN}/#/event/${eventUrlIds?.preview}?isPreview=true`
      : "";

    return [preview, details];
  }, [eventUrlIds?.eventDetails, eventUrlIds?.preview]);

  if (!previewUrl && !detailsUrl) {
    return null;
  }

  return (
    <>
      {detailsUrl && (
        <Form.Item
          label={
            <FormattedMessage defaultMessage="Event Live URL (url works after the publish date)" />
          }
        >
          <Input readOnly value={detailsUrl} />
        </Form.Item>
      )}
      {previewUrl && (
        <Form.Item
          label={
            <FormattedMessage defaultMessage="Preview URL (valid for 1 hour - use this url to check the event before publish date. Ticket purchases are disabled)" />
          }
        >
          <Input readOnly value={previewUrl} />
        </Form.Item>
      )}
      <Divider />
    </>
  );
};

export default PreviewBox;
